module.exports = __webpack_public_path__ + "img/46.055e5046.png";